import { createContext, useCallback, useState } from 'react';
import { Catalog, MerchantTerminal } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';
import { errorMessage } from '../../utils/access';

type MerchantTerminalsContextProps = {
    terminals: MerchantTerminal[];
    currencies: Catalog[];
    isLoading: boolean;
    loadTerminals: (merchantId: number) => Promise<string>;
    saveTerminal: (terminal: Partial<MerchantTerminal>) => Promise<string>;   // crea o actualiza según tenga id
    deleteTerminal: (id: number) => Promise<string>;                          // borrado lógico
}

export const MerchantTerminalsContext = createContext({} as MerchantTerminalsContextProps);

// Terminales de un comercio del banco Swiftpay (plataforma o usuarios del banco Swiftpay)
export const MerchantTerminalsProvider = ({ children }: any) => {

    const [terminals, setTerminals] = useState<MerchantTerminal[]>([]);
    const [currencies, setCurrencies] = useState<Catalog[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const loadTerminals = useCallback(async (merchantId: number) => {
        setIsLoading(true);
        try {
            const resp = await topApi.get<{ terminals: MerchantTerminal[]; currencies: Catalog[] }>(`/merchantTerminal/merchant/${merchantId}`);
            setTerminals(resp.data.terminals ?? []);
            setCurrencies(resp.data.currencies ?? []);
            return 'success';
        } catch (e) {
            setTerminals([]);
            return errorMessage(e, 'No se pudieron cargar las terminales del comercio, intente de nuevo.');
        } finally {
            setIsLoading(false);
        }
    }, []);

    const saveTerminal = async (terminal: Partial<MerchantTerminal>) => {
        try {
            if (terminal.id) {
                const resp = await topApi.put<{ terminal: MerchantTerminal }>(`/merchantTerminal/${terminal.id}`, { terminal });
                setTerminals(prev => prev.map(item => item.id === terminal.id ? resp.data.terminal : item));
            } else {
                const resp = await topApi.post<{ terminal: MerchantTerminal }>('/merchantTerminal/', { terminal });
                setTerminals(prev => [...prev, resp.data.terminal]);
            }
            return 'success';
        } catch (e) {
            return errorMessage(e);
        }
    }

    const deleteTerminal = async (id: number) => {
        try {
            await topApi.delete(`/merchantTerminal/${id}`);
            setTerminals(prev => prev.filter(item => item.id !== id));
            return 'success';
        } catch (e) {
            return errorMessage(e);
        }
    }

    return (
        <MerchantTerminalsContext.Provider value={{ terminals, currencies, isLoading, loadTerminals, saveTerminal, deleteTerminal }}>
            {children}
        </MerchantTerminalsContext.Provider>
    );
}
